import React from "react";
import Link from "next/link";
import {
  ListItem,
  ListItemText,
  ListItemButton,
  Typography,
  List,
  Box,
} from "@mui/material";
import { useTheme } from "@/context";


interface SidebarSubmenuProps {
  handleSubmenuSelect: (index: number, name:string) => void;
  submenuSelected: number | null;
  submenu: {
    id: number;
    key:string; 
    name: string; 
    submenuPath: string 
  }[];
  menuTitle: string;
  menuIcon: string;
  menuColor: string;
  pathPrefix: string;
  menuId: string
}

const SidebarSubMenu: React.FC<SidebarSubmenuProps> = ({
  handleSubmenuSelect,
  submenuSelected,
  submenu,
  menuTitle,
  menuIcon,
  menuColor,
  pathPrefix,
  menuId,
}) => {
  const {darkMode} = useTheme();
  const regularTextColor = darkMode?"#E0E0E0":"#2C2C2C";
  return (
    <List>
      {submenu.map((submenuItem, subMenuItemIndex) => {
        const path =
          submenuItem.submenuPath && submenuItem.submenuPath !== "/" && submenuItem.submenuPath !== ""
            ? submenuItem.submenuPath === pathPrefix 
              ? pathPrefix  // Special case: if submenuPath equals pathPrefix, use just pathPrefix
              : pathPrefix + submenuItem.submenuPath
            : submenuItem.submenuPath === ""
              ? pathPrefix  // Special case: if submenuPath is empty, use just pathPrefix
              : `/submenu-fallback?name=${encodeURIComponent(submenuItem.name)}&menuTitle=${encodeURIComponent(menuTitle)}&menuIcon=${encodeURIComponent(menuIcon)}`;

        return (
          <Link href={path} passHref key={`submenu-` + submenuItem.id}>
            <Box className="pl-10">
              <ListItem
                disablePadding
                sx={{
                  borderLeft: "1px solid",
                  borderLeftColor: "#A0A0A0",
                  display: "flex",
                  alignItems: "center", 
                }}
                onClick={() => handleSubmenuSelect(Number(submenuItem.id),submenuItem.name)}
              >
                <ListItemButton className="p-0" sx={{ padding: 0 }}>
                  <ListItemText
                    className="border-l-2 pr-9"
                    sx={{
                      minHeight: "30px",
                      display: "flex", 
                      alignItems: "center", 
                      borderLeftColor: submenuSelected === Number(submenuItem.id) ? menuColor : "transparent",
                    }}
                  >
                    <Typography
                      className="pl-4 font-cerebri font-normal text-sm"
                      sx={{
                        color: submenuSelected === Number(submenuItem.id) ? menuColor : regularTextColor,
                        fontFamily: "Cerebri Sans",
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        lineHeight: "1.25rem",
                        textAlign: "left",
                      }}
                    >
                      {submenuItem.name}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Box>
          </Link>
        );
      })}
    </List>
  );
};

export default SidebarSubMenu;
